export { default } from '../VehicleDetailsPage.js';
